import { useState } from "react";
import MailTemplateAction from "./MailTemplateAction.ts";
import ResponseData from "../../../action/ResponseData.ts";
import MailTemplate from "./MailTemplate.ts";
import MailTemplateUpdateForm from "./MailTemplateUpdateForm.ts";
import MailTemplateTestForm from "./MailTemplateTestForm.ts";
function useMailTemplateState() {
    const [list, setList] = useState<Array<MailTemplate> | null>(null);
    const [item, setItem] = useState<MailTemplate | null>(null);
    const [error, setError] = useState(null);
    const [updated_at, setUpdatedAt] = useState<Date | null>(null);

    type MailTemplateJson = {
        id: string;
        from_name: string;
        from_address: string;
        title: string;
        body: string | null;
        send_type: number;
    };

    const loadListHandler = async (data: unknown) => {
        const responseData = data as ResponseData;
        if (responseData.data) {
            // responseData.dataがPromiseの場合は.thenを使用
            if (responseData.data.then && typeof responseData.data.then === "function") {
                const result = await responseData.data;

                const templates = result.templates || result; // APIレスポンスの構造に応じて調整

                if (Array.isArray(templates)) {
                    setList(
                        templates.map((item: MailTemplateJson) => {
                            return new MailTemplate(item.id, item.send_type, item.title, item.from_address, item.from_name, item.body);
                        }),
                    );
                    setUpdatedAt(new Date());
                } else {
                    console.error("Templates is not an array:", templates);
                }
            } else {
                // responseData.dataが既に解決済みオブジェクトの場合

                const templates = responseData.data.templates || responseData.data;

                if (Array.isArray(templates)) {
                    setList(
                        templates.map((item: MailTemplateJson) => {
                            return new MailTemplate(item.id, item.send_type, item.title, item.from_address, item.from_name, item.body);
                        }),
                    );
                    setUpdatedAt(new Date());
                } else {
                    console.error("Templates is not an array:", templates);
                }
            }
        }
    };

    const loadHandler = async (data: unknown) => {
        const responseData = data as ResponseData;
        if (responseData.data) {
            // responseData.dataがPromiseの場合は.thenを使用
            if (responseData.data.then && typeof responseData.data.then === "function") {
                const result = await responseData.data;

                const template = result.template || result; // APIレスポンスの構造に応じて調整

                if (template) {
                    // 単一のアイテムを設定
                    const newTemplate = new MailTemplate(
                        template.id,
                        template.send_type,
                        template.title,
                        template.from_address,
                        template.from_name,
                        template.body,
                    );

                    setItem(newTemplate);
                    setUpdatedAt(new Date());
                } else {
                    console.error("Template data is not available:", template);
                }
            } else {
                // responseData.dataが既に解決済みオブジェクトの場合
                console.log("API response (single item):", responseData.data);
                const template = responseData.data.template || responseData.data;

                if (template) {
                    // 単一のアイテムを設定
                    const newTemplate = new MailTemplate(
                        template.id,
                        template.send_type,
                        template.title,
                        template.from_address,
                        template.from_name,
                        template.body,
                    );

                    setItem(newTemplate);
                    setUpdatedAt(new Date());
                } else {
                    console.error("Template data is not available:", template);
                }
            }
        }
    };
    const loadTestHandler = (data: unknown) => {
        console.log("Test mail sent response:", data);
    };
    const errorHandler = (error: unknown) => {
        const responseError = error as ResponseData;
        setError(responseError.error);
    };

    const getList = (token: string, accommodation_id: string) => {
        MailTemplateAction.getList(token, accommodation_id, loadListHandler, errorHandler);
    };

    const getDetail = (token: string, accommodation_id: string, id: string) => {
        MailTemplateAction.getDetail(token, accommodation_id, id, loadHandler, errorHandler);
    };

    const create = (token: string, accommodation_id: string, form: MailTemplateUpdateForm) => {
        MailTemplateAction.create(token, accommodation_id, form, loadHandler, errorHandler);
    };

    const update = (token: string, accommodation_id: string, id: string, form: MailTemplateUpdateForm) => {
        MailTemplateAction.update(token, accommodation_id, id, form, loadHandler, errorHandler);
    };

    const sendTestMail = (token: string, accommodation_id: string, id: string, form: MailTemplateTestForm) => {
        MailTemplateAction.sendTestMail(token, accommodation_id, id, form, loadTestHandler, errorHandler);
    };

    return {
        mail_template_error: error,
        mail_template_updated_at: updated_at,
        mail_template_list: list,
        mail_template_item: item,
        getMailTemplateList: getList,
        getMailTemplateDetail: getDetail,
        createMailTemplate: create,
        updateMailTemplate: update,
        sendTestMail,
    };
}

export default useMailTemplateState;
